import cx from 'classnames';
import Unity, { UnityContext } from 'react-unity-webgl';
import { UNITY_REF } from '../../constants/product3DModelConstants';
import { useEffect, useMemo, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import {
  selectProduct3DModelAssetLoaded,
  selectProduct3DModelUnitySceneLoaded,
  upload3DModelProductActions,
} from '../../redux/slicers/upload3DModelProductSlicer';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/Button';
import { useUserContext } from '../../contexts/UserContext';

export const product3DModelUnityContext = new UnityContext(UNITY_REF);

export const ProductModel3DSection = ({ product = null, className = '' }) => {
  const dispatch = useDispatch();
  const [modelViewMode, setModelViewMode] = useState(false);
  const { currentUser } = useUserContext();

  const { file } = useMemo(() => {
    const { product_file, is_windows_and_doors, product_file_window_door, is_prop_group } =
      product || {};
    return {
      file: is_prop_group ? null : is_windows_and_doors ? product_file_window_door : product_file,
    };
  }, [product]);

  const product3DModelUnitySceneLoaded = useSelector(selectProduct3DModelUnitySceneLoaded);
  const product3DModelAssetLoaded = useSelector(selectProduct3DModelAssetLoaded);

  const handleUnityE = () =>
    product3DModelUnityContext.send('ProductModule', 'WebglKeyBoard', 'True');

  const handleUnityL = () =>
    product3DModelUnityContext.send('ProductModule', 'WebglKeyBoard', 'False');

  const handleModeSwitch = () => {
    setModelViewMode(!modelViewMode);
    product3DModelUnityContext.send('ProductModule', 'ToggleMode');
  };

  useEffect(() => {
    return () => {
      handleUnityL();
      dispatch(upload3DModelProductActions.setProduct3DModelUnitySceneLoaded(false));
      dispatch(upload3DModelProductActions.setProduct3DModelAssetLoaded(false));
    };
  }, []);

  useEffect(async () => {
    if (product3DModelUnitySceneLoaded && file && typeof file === 'string') {
      console.log('DEBUG___LoadModelReceiver', {
        file,
        product3DModelUnitySceneLoaded,
        product,
      });
      product3DModelUnityContext?.sentryUnityModule?.initUser({
              user_id: currentUser?.user?.id,
              user_email: currentUser?.user?.email,
              organization_id: currentUser?.organization_detail?.id,
              organization_name: currentUser?.organization_detail?.name,
              environment : process.env.REACT_APP_ENV,
              url : window.location.href, 
            });
      const response = await fetch(file);
      if (response.status === 200) {
        product3DModelUnityContext.send('ProductModule', 'LoadModelReceiver', file);
      }
    }
  }, [file, product3DModelUnitySceneLoaded]);

  const loading = file ? !product3DModelAssetLoaded : false;

  if (!file) return null;
  return (
    <div
      className={cx('w-100 position-relative', className)}
      onMouseEnter={handleUnityE}
      onMouseLeave={handleUnityL}>
      <Loader loading={loading} position="absolute" />
      <Unity unityContext={product3DModelUnityContext} style={{ width: '100%', height: '100%' }} />

      <Button
        size="xs"
        className="position-absolute"
        style={{
          right: '1rem',
          bottom: '1rem',
          zIndex: 1000,
        }}
        disabled={loading}
        onClick={handleModeSwitch}>
        Free Mode {modelViewMode ? 'ON' : 'OFF'}
      </Button>
    </div>
  );
};
